import { Link } from "react-router-dom";
import { BookOpen, Users, FileText, Building, Globe, Handshake, Eye, ArrowRight, Download, ExternalLink, Heart, TrendingUp, Shield, Landmark } from "lucide-react";

const SECTIONS = [
  { path: "/chi-siamo/organismi", icon: Users, titolo: "Organismi", desc: "Presidente, Direttore, Giunta, Consiglio Direttivo e Team." },
  { path: "/chi-siamo/statuto-e-regolamenti", icon: FileText, titolo: "Statuto e Regolamenti", desc: "Documenti istituzionali, codice etico, certificazioni." },
  { path: "/associazioni", icon: Building, titolo: "Associazioni", desc: "15 Federazioni e Associazioni di categoria del territorio." },
  { path: "/chi-siamo/enti-collegati/promo-ter", icon: Globe, titolo: "Promo.Ter", desc: "Società di servizi per formazione professionale, consulenza e assistenza alle imprese." },
  { path: "/chi-siamo/cat", icon: Globe, titolo: "C.A.T. Confcommercio Roma", desc: "Centro di Assistenza Tecnica per le imprese del commercio, turismo e servizi di Roma." },
  { path: "/chi-siamo/partner", icon: Handshake, titolo: "Partner", desc: "50&Piu Enasco, CIOL, EBIT, Finpromoter, Fon.Te., For.Te., Sanimpresa." },
  { path: "/chi-siamo/trasparenza", icon: Eye, titolo: "Trasparenza", desc: "Archivio contributi pubblici e pubblicazioni." },
];

const SECTION_IMAGES = {
  "Organismi": "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=600&q=80&auto=format",
  "Statuto e Regolamenti": "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=600&q=80&auto=format",
  "Associazioni": "https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=600&q=80&auto=format",
  "Promo.Ter": "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&q=80&auto=format",
  "C.A.T. Confcommercio Roma": "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&q=80&auto=format",
  "Partner": "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=600&q=80&auto=format",
  "Trasparenza": "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=600&q=80&auto=format",
};

const TIMELINE = [
  { anno: "1944", titolo: "La fondazione", desc: "19 associazioni e sindacati di categoria danno vita al primo nucleo di Confcommercio Roma." },
  { anno: "1971", titolo: "La crescita", desc: "La Confederazione diventa la voce del commercio, del turismo e dei servizi nella Capitale." },
  { anno: "2006", titolo: "Modernizzazione", desc: "Trasparenza, riforma statutaria e digitalizzazione sotto la presidenza Sangalli." },
  { anno: "2024", titolo: "80 anni", desc: "Celebrazione con il Tour Roadshow itinerante su tutto il territorio romano." },
  { anno: "2025", titolo: "Nuovo logo", desc: "Identità visiva rinnovata: lineare, essenziale, moderna. Lo sguardo al futuro." },
];

export default function ChiSiamoPage() {
  return (
    <main id="main-content" data-testid="chi-siamo-page">
      {/* Hero */}
      <section className="relative h-[320px] md:h-[380px] overflow-hidden" aria-labelledby="chisiamo-title">
        <img src="https://images.unsplash.com/photo-1552832230-c0197dd311b5?w=1920&q=60&auto=format" alt="Roma" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(4, 30, 66, 0.82)" }} />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative h-full flex flex-col justify-end pb-12">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">L'Associazione</span>
          <h1 id="chisiamo-title" className="text-4xl md:text-5xl font-bold text-white mt-3 font-['Encode_Sans_Semi_Condensed'] tracking-tight">Chi Siamo</h1>
          <p className="text-lg text-white/80 mt-4 max-w-3xl">
            Confcommercio Roma è un'associazione di imprese del Commercio, del Turismo, dei Servizi e delle Attività Professionali aderente a Confcommercio-Imprese per l'Italia.
          </p>
        </div>
      </section>

      {/* Timeline orizzontale */}
      <section className="py-16 bg-white overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">La nostra storia</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[var(--confcom-text-primary)] mt-3 font-['Encode_Sans_Semi_Condensed'] tracking-tight">Dal 1944 al fianco delle imprese</h2>
          </div>
          {/* Timeline */}
          <div className="relative">
            <div className="hidden md:block absolute top-[40px] left-0 right-0 h-[2px] bg-gradient-to-r from-[var(--confcom-blue)] via-[#56B7E6] to-[var(--confcom-blue)]" />
            <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
              {TIMELINE.map((t, i) => (
                <div key={t.anno} className="relative text-center">
                  <div className="relative z-10 w-20 h-20 bg-[var(--confcom-blue)] rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                    <span className="text-xl font-bold text-white font-['Encode_Sans_Semi_Condensed']">{t.anno}</span>
                  </div>
                  <h3 className="text-base font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-1">{t.titolo}</h3>
                  <p className="text-xs text-[var(--confcom-text-secondary)] leading-relaxed">{t.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Zig-zag storytelling */}
      <section className="py-16 bg-[#EBF5FF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
          {/* Blocco 1: testo sx, foto dx */}
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <p className="text-lg text-[var(--confcom-text-secondary)] leading-relaxed mb-4">La nostra storia è iniziata l'<strong className="text-[var(--confcom-text-primary)]">11 ottobre del 1944</strong> quando un piccolo gruppo di imprenditori, con spirito di libertà e voglia di ricostruire, diede vita a 19 associazioni che costituirono il primo nucleo di Confcommercio Roma.</p>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-4">Da allora siamo cresciuti lavorando al fianco delle imprese, ascoltando le loro esigenze e costruendo insieme soluzioni efficaci per stare al passo con i tempi.</p>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed">L'esperienza maturata ha permesso all'associazione di diventare l'<strong className="text-[var(--confcom-text-primary)]">interlocutore privilegiato</strong> di Enti e Amministrazioni locali.</p>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg">
              <img src="https://images.unsplash.com/photo-1529260830199-42c24126f198?w=800&q=80&auto=format" alt="Roma storica" className="w-full h-[300px] object-cover" />
            </div>
          </div>
          {/* Blocco 2: foto sx, testo dx */}
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="rounded-2xl overflow-hidden shadow-lg order-2 lg:order-1">
              <img src="https://images.unsplash.com/photo-1556761175-4b46a572b786?w=800&q=80&auto=format" alt="Team moderno" className="w-full h-[300px] object-cover" />
            </div>
            <div className="order-1 lg:order-2">
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-4">Oggi le imprese associate provengono dai più svariati settori: dall'accoglienza alla ristorazione, dalla consulenza alla sicurezza, dal commercio alla distribuzione.</p>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-6">Scelgono di far parte del nostro sistema perché sanno di poter contare sui consigli e l'assistenza dei nostri esperti fin dai primissimi momenti d'attività.</p>
              <a href="https://www.confcommercioroma.it/wp-content/uploads/2024/05/COMPANY-PROFILE-CONFCOMMERCIO-ROMA.pdf" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[var(--confcom-blue)] text-white px-7 py-3 rounded-md font-medium hover:opacity-90 transition-opacity text-sm">
                <Download size={16} aria-hidden="true" /> Brochure Istituzionale (PDF)
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Numeri d'impatto */}
      <section className="py-16 relative overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=1920&q=60&auto=format" alt="" className="w-full h-full object-cover" aria-hidden="true" />
          <div className="absolute inset-0" style={{ backgroundColor: "rgba(4, 30, 66, 0.92)" }} />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            {[
              { value: "80", suffix: "", label: "Anni di storia" },
              { value: "2.000", suffix: "+", label: "Aziende associate" },
              { value: "15", suffix: "", label: "Associazioni di categoria" },
              { value: "40.000", suffix: "+", label: "Lavoratori rappresentati" },
            ].map((stat) => (
              <div key={stat.label} className="bg-white/[0.08] backdrop-blur-sm border border-white/10 rounded-2xl p-8">
                <div className="text-4xl md:text-5xl font-bold text-white font-['Encode_Sans_Semi_Condensed']">{stat.value}<span className="text-[#56B7E6]">{stat.suffix}</span></div>
                <div className="text-sm text-white/60 mt-2">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission e Vision — blocco immersivo */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-0">
            {/* Mission */}
            <div className="p-10 md:p-14 bg-[var(--confcom-blue)] rounded-t-2xl md:rounded-l-2xl md:rounded-tr-none">
              <div className="w-14 h-14 bg-white/15 rounded-2xl flex items-center justify-center mb-6">
                <TrendingUp size={28} className="text-white" aria-hidden="true" />
              </div>
              <h2 className="text-2xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] mb-6">Mission</h2>
              <div className="text-white/80 leading-relaxed space-y-4">
                <p>Confcommercio Roma si impegna ogni giorno a essere <strong className="text-white">al fianco delle imprese</strong>, ascoltando le loro sfide e costruendo percorsi verso il futuro.</p>
                <p>Abbracciamo il potere della trasformazione e rappresentiamo la volontà di costruire, rinnovare e ridefinire il concetto di <strong className="text-white">progresso</strong>. Il nostro spirito si ispira alla libertà imprenditoriale, alla creatività e all'innovazione.</p>
                <p>Il nostro obiettivo concreto è essere un <strong className="text-white">pilastro per le comunità locali</strong>, un punto di riferimento per le istituzioni e un motore che alimenta la crescita e la modernizzazione della Capitale e dell'Italia.</p>
                <p>Siamo una <strong className="text-white">comunità di innovatori</strong> che fanno impresa insieme, rappresentando un esempio tangibile di cambiamento positivo. <strong className="text-white">Confcommercio Roma: facciamo impresa con passione e impegno.</strong></p>
              </div>
            </div>
            {/* Vision */}
            <div className="p-10 md:p-14 bg-[#041E42] rounded-b-2xl md:rounded-r-2xl md:rounded-bl-none">
              <div className="w-14 h-14 bg-white/10 rounded-2xl flex items-center justify-center mb-6">
                <Landmark size={28} className="text-[#56B7E6]" aria-hidden="true" />
              </div>
              <h2 className="text-2xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] mb-6">Vision</h2>
              <div className="text-white/70 leading-relaxed space-y-4">
                <p>Miriamo a creare un ecosistema in cui gli imprenditori e i professionisti possano prosperare, guidati dalla nostra costante dedizione a fornire supporto di alto livello e risorse essenziali per la gestione efficace delle loro attività.</p>
                <p>Guardiamo oltre le sfide attuali, per immaginare un futuro in cui le imprese possano operare in un ambiente favorevole, con un accesso semplificato alle risorse, alle opportunità di sviluppo e alla rappresentanza istituzionale.</p>
                <p>Con una visione orientata alla creazione di valore e alla sostenibilità a lungo termine, aspiriamo a essere un <strong className="text-[#56B7E6]">faro di guida</strong> e ispirazione per la comunità imprenditoriale, promuovendo: innovazione, competitività e prosperità economica.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 80 anni + Video */}
      <section className="py-16 bg-[#EBF5FF]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed']">Gli 80 anni di Confcommercio Roma</h2>
            <p className="text-[var(--confcom-text-secondary)] mt-3">Istituzioni, imprenditori e cittadini insieme per il futuro del commercio nella Capitale.</p>
          </div>
          <div className="rounded-xl overflow-hidden border border-[var(--confcom-border)] shadow-lg" data-testid="video-80-anni">
            <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
              <iframe
                className="absolute inset-0 w-full h-full"
                src="https://www.youtube.com/embed/OJIZwAiWWj8"
                title="Gli 80 anni di Confcommercio Roma"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
              />
            </div>
          </div>
          <div className="mt-6 text-center">
            <a href="https://www.confcommercioroma.it/progetti/80-anni-tour-roadshow/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[var(--confcom-blue)] text-white px-7 py-3 rounded-md font-medium hover:opacity-90 transition-opacity text-sm" data-testid="cta-roadshow">
              <ExternalLink size={16} aria-hidden="true" /> Scopri il progetto 80 Anni Tour Roadshow
            </a>
          </div>
        </div>
      </section>

      {/* Impegno sociale */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Il nostro impegno</span>
              <h2 className="text-3xl md:text-4xl font-bold text-[var(--confcom-text-primary)] mt-3 mb-6 font-['Encode_Sans_Semi_Condensed'] tracking-tight">
                Inclusione e supporto sociale
              </h2>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-4">
                Confcommercio Roma crede che fare impresa significhi anche costruire una società più giusta. Per questo promuoviamo attivamente progetti di inclusione, solidarietà e supporto alle categorie più fragili del nostro territorio.
              </p>
              <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-8">
                Dalla parità di genere alla sostenibilità ambientale, dalla legalità all'inserimento lavorativo: il nostro impegno sociale è parte integrante della nostra missione.
              </p>
              <Link to="/chi-siamo/il-nostro-impegno" className="inline-flex items-center gap-2 bg-[var(--confcom-blue)] text-white px-7 py-3 rounded-md font-medium hover:opacity-90 transition-opacity text-sm">
                Scopri il nostro impegno <ArrowRight size={16} aria-hidden="true" />
              </Link>
            </div>
            <div className="rounded-2xl overflow-hidden">
              <img src="/impegno-sociale.jpg" alt="Inclusione e supporto sociale" className="w-full h-[320px] object-cover" />
            </div>
          </div>
        </div>
      </section>

      {/* Sezioni di navigazione */}
      <section className="py-16 bg-[var(--confcom-bg-subtle)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-10 text-center">Scopri di più</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {SECTIONS.map((s) => (
              <Link key={s.path} to={s.path} className="group bg-white rounded-xl overflow-hidden border border-[var(--confcom-border)] hover:border-[var(--confcom-blue)]/30 hover:shadow-lg transition-all" data-testid={`chisiamo-link-${s.titolo.toLowerCase().replace(/\s/g, "-")}`}>
                <div className="h-40 overflow-hidden">
                  <img src={SECTION_IMAGES[s.titolo]} alt={s.titolo} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                </div>
                <div className="p-6">
                  <s.icon size={24} className="text-[var(--confcom-blue)] mb-3 group-hover:scale-110 transition-transform" aria-hidden="true" />
                  <h3 className="text-lg font-semibold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-2 group-hover:text-[var(--confcom-blue)] transition-colors">{s.titolo}</h3>
                  <p className="text-sm text-[var(--confcom-text-secondary)] leading-relaxed mb-4">{s.desc}</p>
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-[var(--confcom-blue)] group-hover:gap-2 transition-all">
                    Scopri <ArrowRight size={14} aria-hidden="true" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
